export const eyeColorOptions = [
  'Black',
  'Blue',
  'Brown',
  'Gray',
  'Green',
  'Hazel',
  'Maroon',
  'Multicolored',
  'Pink',
  'Unknown',
];

export const hairColorOptions = [
  'Bald',
  'Black',
  'Blonde',
  'Brown',
  'Gray',
  'Red',
  'Sandy',
  'White',
  'Blue',
  'Green',
  'Orange',
  'Pink',
  'Purple',
  'Unknown',
];

export const sexOptions = ['Female', 'Male'];
